import { AuthConstants, ForgotPasswordConstants } from './types';

export const authInitialState = {
  loggedIn: false,
  user: undefined,
  error: undefined,
};

export function authReducer(state = authInitialState, action) {
  switch (action.type) {
    case AuthConstants.LoginSuccess:
      window.localStorage.setItem('refresh_token', JSON.stringify(action.payload.refresh_token));
      window.sessionStorage.setItem('token', JSON.stringify(action.payload.token));
      return {
        ...state,
        user: action.payload.user,
        loggedIn: true,
        error: undefined,
      };
    case AuthConstants.LoginFailure:
      window.sessionStorage.removeItem('token');
      return {
        ...state,
        user: undefined,
        loggedIn: false,
        error: 'The username or password you entered is invalid.',
      };
    case AuthConstants.Logout:
      window.localStorage.removeItem('refresh_token');
      window.sessionStorage.clear();
      return {
        ...state,
        user: undefined,
        loggedIn: false,
      };
    case AuthConstants.LoginError:
      window.localStorage.removeItem('refresh_token');
      window.sessionStorage.removeItem('token');
      return {
        ...state,
        user: undefined,
        loggedIn: false,
        error: action.payload,
      };
    default:
      return state;
  }
}

export const forgotPasswordInitialState = {
  forgotPasswordMessage: undefined,
  forgotPasswordError: undefined,
};

export function forgotPasswordReducer(state = forgotPasswordInitialState, action) {
  switch (action.type) {
    case ForgotPasswordConstants.EmailSent:
      return {
        ...state,
        forgotPasswordMessage: 'Please check your inbox for instructions to reset your password.',
        forgotPasswordError: undefined,
      };
    case ForgotPasswordConstants.EmailNotSent:
      return {
        ...state,
        forgotPasswordMessage: undefined,
        forgotPasswordError: action.payload,
      };
    case ForgotPasswordConstants.ClearStatus:
      return {
        ...state,
        forgotPasswordMessage: undefined,
        forgotPasswordError: undefined,
      };
    default:
      return state;
  }
}
